export function toggleModal(modalOpen, children, chave, icon) {
  return {
    type: '@modal/TOGGLE',
    payload: { modalOpen, children, chave, icon },
  };
}
